<template>
  <div class="time-sheet">
    <CCard class="filter">
      <CRow>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>{{ $t("timeSheets.id_name") }}</label>
            </CCol>
            <CCol sm="12">
              <CInput
                type="text"
                v-model="searchData.employee_info"
                :placeholder="
                  this.$t(
                    'placeholder.label_employee_over_time_request_search_code_name'
                  )
                "
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>Foot</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.foot_code"
                @change="search"
              >
                <option value="0">{{
                  $t("placeholder.label_employee_option_search")
                }}</option>
                <option
                  v-for="foot in foots"
                  :key="foot.id"
                  :value="foot.code"
                  >{{ foot.name }}</option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>{{
                $t("sabbatical-compensate.label_compensate_division")
              }}</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.division_code"
                @change="search"
              >
                <option value="0">{{
                  $t("placeholder.label_employee_option_search")
                }}</option>
                <option
                  v-for="division in filterDivision"
                  :key="division.id"
                  :value="division.code"
                  >{{ division.name }}</option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol col="12">
              <label>{{
                $t("sabbatical-compensate.label_month_compensate")
              }}</label>
            </CCol>
            <CCol col="12">
              <select
                class="form-control"
                v-model="searchData.time_compensate"
                @change="search"
              >
                <option
                  v-for="(item, index) in options"
                  :key="index"
                  :value="item"
                  >{{ item }}</option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol col="12">
              <label>{{ $t("commons.label_status") }}</label>
            </CCol>
            <CCol col="12">
              <div class="form-group">
                <select
                  class="form-control"
                  v-model="searchData.status"
                  @change="search"
                >
                  <option value="0">{{ $t("employee.select_option") }}</option>
                  <option value="1">{{
                    $t("commons.label_status_overtime_request_1")
                  }}</option>
                  <option value="2">{{
                    $t("commons.label_status_overtime_request_2")
                  }}</option>
                  <option value="3">{{
                    $t("commons.label_status_overtime_request_3")
                  }}</option>
                </select>
              </div>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol col="12">
              <label>{{
                $t("sabbatical-compensate.label_approve_person")
              }}</label>
            </CCol>
            <CCol col="12">
              <CInput
                v-model="searchData.approvePerson"
                :placeholder="
                  this.$t('placeholder.label_approve_person_over_time_request')
                "
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="justify-content-center btn-search-mb">
        <CButton @click="search" class="btn-search-timesheet">{{
          $t("label.search")
        }}</CButton>
        <CButton class="btn-reset" @click="resetForm">{{
          $t("button.label_action_reset")
        }}</CButton>
      </CRow>
    </CCard>
    <div class="table-list">
      <CCard class="mt-4">
        <CCardBody>
          <!-- <CRow class="justify-content-end p-2"> -->
          <!-- <CButton color="info mr-3" @click="importTimesheet">Import</CButton>
            <CButton color="warning ml-3" @click="exportData">Export</CButton> -->
          <!-- </CRow> -->
          <div class="option-table">
            <div class="form-group">
              <select
                class="form-control"
                v-model="searchData.itemsPerPage"
                @change="search"
              >
                <option
                  v-for="item in listItemsPerPage"
                  :value="item"
                  :key="item"
                  >{{ item }}</option
                >
              </select>
            </div>
            <template
              v-if="
                sabbaticalCompensateRequest.data &&
                  sabbaticalCompensateRequest.data.length > 0
              "
            >
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ $t("commons.label_text_to") }} {{ searchData.paginate.to }}
                {{ $t("commons.label_text_of") }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
            <template v-else>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ searchData.paginate.to }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
          </div>
          <div class="table-responsive">
            <table class="table table-mobile table-tablet">
              <thead>
                <tr>
                  <th>#</th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.employee_code)"
                  >
                    {{ $t("label.employee_code") }}
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.employee_code)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.employee_name)"
                  >
                    {{ $t("label.full_name") }}
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.employee_name)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.foot_code)"
                  >
                    Foot
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.foot_code)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.division)"
                  >
                    {{ $t("label.division") }}
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.division)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.time_compensate)"
                  >
                    {{ $t("sabbatical-compensate.label_time_compensate") }}

                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.time_compensate)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.workday_actual)"
                  >
                    {{ $t("sabbatical-compensate.label_workday_actual") }}
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.workday_actual)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.workday_payroll)"
                  >
                    {{ $t("sabbatical-compensate.label_workday_payroll") }}
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort(columnSort.workday_payroll)"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="cl-pointer text-center"
                    @click="sortByColumn(columnSort.number_of_day_compensate)"
                  >
                    {{
                      $t("sabbatical-compensate.label_number_of_day_compensate")
                    }}
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="
                          classStatusSort(columnSort.number_of_day_compensate)
                        "
                      ></CIcon>
                    </span>
                  </th>
                  <th class="cl-pointer text-center">
                    {{
                      $t("sabbatical-compensate.label_worday_after_compensate")
                    }}
                  </th>
                  <th>{{ $t("sabbatical-compensate.label_confirm_info") }}</th>
                  <th>{{ $t("sabbatical-compensate.label_status") }}</th>
                  <th>{{ $t("sabbatical-compensate.label_action") }}</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-if="
                    sabbaticalCompensateRequest.data &&
                      sabbaticalCompensateRequest.data.length > 0
                  "
                >
                  <tr
                    v-for="(compensate,
                    index) in sabbaticalCompensateRequest.data"
                    :key="compensate.id"
                  >
                    <th>{{ index + 1 }}</th>
                    <td>{{ compensate.employee_id }}</td>
                    <td>{{ compensate.employee_name }}</td>
                    <td>{{ compensate.foot_code }}</td>
                    <td>{{ compensate.department_code }}</td>
                    <td>{{ compensate.time_compensate }}</td>
                    <td>{{ compensate.workday_actual }}</td>
                    <td>{{ compensate.workday_payroll }}</td>
                    <td>{{ compensate.number_of_day_compensate }}</td>
                    <td>{{ compensate.worday_after_compensate }}</td>
                    <td>
                      <ul class="pl-0 mb-0">
                        <li
                          class="text-left"
                          v-for="(item,
                          key) in compensate.monthly_work_time_additional_approve"
                          :key="key"
                        >
                          <template>
                            {{ item.approve_by }} :
                            {{
                              $t(`overtime.employee_approval_${item.status}`)
                            }}
                          </template>
                        </li>
                      </ul>
                    </td>
                    <td
                      v-bind:class="
                        compensate.status
                          ? 'color-status-' + compensate.status
                          : ''
                      "
                    >
                      <CBadge color="secondary">{{
                        $t(
                          `commons.label_status_overtime_request_${compensate.status}`
                        )
                      }}</CBadge>
                    </td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Sabbatical.compensate.detail',
                          params: { id: compensate.id }
                        }"
                        tag="a"
                      >
                        <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          >{{ $t("button.label_action_show") }}</CButton
                        >
                      </router-link>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="
            sabbaticalCompensateRequest.data &&
              sabbaticalCompensateRequest.data.length > 0
          "
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="changePage"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TimeSheet",
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_compensate_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      searchData: {
        foot_code: "0",
        division_code: "0",
        employee_info: "",
        time_compensate: this.getNowMonth() - 1,
        status: 0,
        approvePerson: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        },
        sortBy: "DESC",
        sortColumn: "time_compensate"
      },
      columnSort: {
        employee_code: "employee_id",
        employee_name: "name",
        time_compensate: "time_compensate",
        workday_actual: "workday_actual",
        workday_payroll: "workday_payroll",
        number_of_day_compensate: "number_of_day_compensate",
        foot_code: "parent_code",
        division: "department_code"
      }
    };
  },
  created() {
    let session = JSON.parse(localStorage.getItem("session"));
    this.searchData.employee_info = session?.employeeInfo;
    this.searchData.foot_code = session?.footCode;
    this.searchData.status = session?.status;
    this.searchData.division_code = session?.divisionCode;
    this.searchData.time_compensate = session?.timeCompensate;
    this.searchData.approvePerson = session?.approvePerson;
    this.fetchCompensateData();
  },
  computed: {
    ...mapGetters({
      pagination: "sabbatical-compensate/pagination",
      foots: "commons/foots",
      divisions: "commons/divisions",
      listItemsPerPage: "commons/listItemsPerPage",
      sabbaticalCompensateRequest:
        "sabbatical-compensate/sabbaticalCompensateRequest"
    }),
    filterDivision() {
      if (this.searchData.foot_code === "0") return this.divisions;
      return this.divisions.filter(
        division => division.parent_code === this.searchData.foot_code
      );
    }
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    resetForm() {
      this.searchData.foot_code = "0";
      this.searchData.division_code = "0";
      this.searchData.employee_info = "";
      this.searchData.status = 0;
      this.searchData.time_compensate = this.getNowMonth() - 1;
      this.searchData.approvePerson = "";
      localStorage.removeItem("session");
    },
    async fetchCompensateData() {
      await this.$store.dispatch("sabbatical-compensate/fetchCompensateData", {
        foot_code: this.searchData.foot_code,
        division_code: this.searchData.division_code,
        employee_info: this.searchData.employee_info,
        time_compensate: this.searchData.time_compensate,
        status: this.searchData.status,
        approvePerson: this.searchData.approvePerson,
        itemsPerPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        sortBy: this.searchData.sortBy,
        sortColumn: this.searchData.sortColumn
      });
      this.searchData.paginate = this.pagination;
    },
    setItemInLocalStorage() {
      let obj = {
        footCode: this.searchData.foot_code,
        divisionCode: this.searchData.division_code,
        timeCompensate: this.searchData.time_compensate,
        employeeInfo: this.searchData.employee_info,
        status: this.searchData.status,
        approvePerson: this.searchData.approvePerson
      };
      localStorage.setItem("session", JSON.stringify(obj));
    },
    async search() {
      if (this.$route.fullPath !== "/sabbatical-compensate/") {
        this.clearParamUrl();
      }
      this.passParamUrl();
      this.searchData.paginate.currentPage = 1;
      this.setItemInLocalStorage();

      this.setLoading(true);
      try {
        await this.fetchCompensateData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    checkDataParam(data) {
      return data === 0 || data === "" ? undefined : data;
    },
    clearParamUrl() {
      this.$router.push({ name: "Sabbatical.compensate" });
    },
    passParamUrl() {
      this.$router.push({
        name: "Sabbatical.compensate",
        query: {
          employeeInfo: this.searchData.employee_info,
          footCode: this.searchData.foot_code,
          divisionCode: this.searchData.division_code,
          approvePerson: this.searchData.approvePerson,
          time_compensate: this.checkDataParam(this.searchData.time_compensate),
          status: this.checkDataParam(parseInt(this.searchData.status)),
          currentPage: this.checkDataParam(
            this.searchData.paginate.currentPage
          ),
          perPage: this.checkDataParam(this.searchData.itemsPerPage),
          sortColumn: this.checkDataParam(this.searchData.sortColumn),
          sortBy: this.checkDataParam(this.searchData.sortBy)
        }
      });
    },
    sortByColumn(column) {
      this.searchData.sortColumn = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      this.passParamUrl();
      this.fetchCompensateData();
    },
    classStatusSort(column) {
      return this.searchData.sortColumn === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },

    getNowMonth() {
      const today = new Date();
      const dateMonth = today.getMonth() + 1;
      return dateMonth;
    },
    changePage(page) {
      this.passParamUrl();
      this.fetchCompensateData(this.searchData.itemsPerPage, page);
    }
  }
};
</script>

<style lang="scss" scoped>
.filter {
  margin: -2rem -2rem 0rem -2rem;
  padding: 2rem;
}
.table-list {
  .cl-pointer {
    cursor: pointer;
    .icon-sort {
      margin-left: 5px;
      .c-icon {
        width: 12px;
      }
      .sort-rotate {
        transform: rotate(180deg);
      }
    }
  }
}
tr.day-off {
  background-color: #f0f8ff;
}
th,
td {
  vertical-align: middle !important;
}
.required,
.error-required {
  color: #dc1313;
  font-size: 13px;
}
.option-table {
  display: flex;
  justify-content: space-between;
}
.btn-search-timesheet {
  background-color: #b5dbf2;
  padding: 8px;
  width: 120px;
}

.btn:focus,
.btn.focus {
  box-shadow: none !important;
}
td > ul {
  list-style-type: none;
  padding-left: 0px;
}
ul {
  list-style-type: none;
}
@media only screen and (max-device-width: 767px) {
  .py-mobile-0 {
    padding: 0 !important;
  }
  .card-body {
    padding: 0.5rem;
  }
  .btn-search-mb {
    margin-top: 15px;
  }
  .table-mobile {
    width: 1700px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1700px;
    overflow-x: scroll;
  }
}
</style>
